import React, { useEffect, useState } from "react";
import "./login.css";
import { Container, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { TextField, Typography } from "@mui/material";
import notify from "../../Notifcation";
import { useDispatch, useSelector } from "react-redux";
import { loginUseraction } from "../../redux/actions/AuthAction";
import { ToastContainer } from "react-toastify";
const Login = () => {
  const [Nationalid, setNationalid] = useState("");
  const [Password, setPassword] = useState("password");
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [isPress, setisPress] = useState(false);

  const [passwordInput, setPasswordInput] = useState("");
  const onPasswordChange = (e) => {
    setPasswordInput(e.target.value);
  };
  const toggle = () => {
    if (Password === "password") {
      setPassword("text");
      return;
    }
    setPassword("password");
  };
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (passwordInput === "" || Nationalid === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setisPress(true);
    await dispatch(
      loginUseraction({
        national_id: Nationalid,
        password: passwordInput,
    
      })
    );
    setLoading(false);
    setisPress(false);
  };
  const res = useSelector((state) => state.authReducer.loginUser);
    useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (res.data && res.data.token) {
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("user", JSON.stringify(res.data));
            notify("تم تسجيل الدخول بنجاح", "success");
            setTimeout(() => {
              if (res.data.user_type === "admin") {
                window.location.href = "/admin";
              } else if (res.data.user_type === "consultant") {
                window.location.href = "/consultant";
              } else {
                window.location.href = "/user/services";
              }
            }, 2000);
          }
        } else if (res.status !== 200 || res.status !== 201) {
          if (res.data && res.data.message) {
            notify(res.data.message, "error");
          } else notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
    }
  }, [loading]);
  return (
    <div className="login">
      <Container>
        <div className="main-log">
          <div className="login-container">
            <h2>تسجيل الدخول</h2>
            <div className="login">
              <div className="login-item">
                <TextField
                  label={
                    <Typography
                    >
                   الرقم القومي
                      <span style={{ color: "red", fontSize: "21px" }}>
                        *
                      </span>
                    </Typography>
                  }
                  type="number"
                  value={Nationalid}
                  onChange={(e) => {
                    setNationalid(e.target.value);
                  }}
                  variant="outlined"
                />
              </div>
              <div className="login-item">
                <TextField
                  label={
                    <Typography
                    >
                  كلمة المرور
                      <span style={{ color: "red", fontSize: "21px" }}>
                        *
                      </span>
                    </Typography>
                  }
                  type={Password}
                  onChange={onPasswordChange}
                  value={passwordInput}
                  variant="outlined"
                />
                <button onClick={toggle}>
                  {Password === "password" ? (
                    <svg
                      width="20"
                      height="17"
                      fill="currentColor"
                      className="bi bi-eye-slash-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z" />
                      <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z" />
                    </svg>
                  ) : (
                    <svg
                      width="20"
                      height="17"
                      fill="currentColor"
                      className="bi bi-eye-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                      <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                    </svg>
                  )}
                </button>
              </div>

              {loading && isPress ? (
                <button className="buttonadd">
                  <Spinner />
                </button>
              ) : (
                <button className="buttonadd" onClick={handlesubmit}>
                  تسجيل الدخول
                </button>
              )}

              <Link to="/forgetpassword">هل نسيت كلمة السر ..؟</Link>

              {/* <Link to="/register">Creat Admin</Link> */}
              {/* <div className="social">
                <i className="fa-brands fa-facebook"></i>
                <i className="fa-brands fa-google"></i>
              </div> */}
            </div>
          </div>
        </div>
      </Container>
      <ToastContainer />
    </div>
  );
};
export default Login;
